import React from 'react';

export default function MetricusSelect({label,helperText='',options=[],className='',...props}){
  return <label className={`metricus-field ${className}`.trim()}>
    {label&&<span className="metricus-field-label">{label}</span>}
    <select {...props} className="metricus-select">
      {options.map(option=><option key={option.value} value={option.value}>{option.label}</option>)}
    </select>
    {helperText&&<span className="metricus-field-help">{helperText}</span>}
  </label>;
}
